import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// kind: "order" | "quote"
// getReferenceId: async () => backend id (order_id/quote_id) or null to abort
export default function PayPalCheckout({ kind, getReferenceId, onSuccess }) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/payments/paypal/config").then(({ data }) => setCfg(data)).catch(() => setCfg({ enabled: false }));
  }, []);

  if (!cfg) return <div className="flex justify-center py-3"><Loader2 className="w-5 h-5 animate-spin text-[#0055FF]" /></div>;
  if (!cfg.enabled || !cfg.client_id) return null;

  return (
    <div data-testid="paypal-checkout">
      <PayPalScriptProvider options={{
        clientId: cfg.client_id,
        currency: cfg.currency || "EUR",
        intent: "capture",
        components: "buttons",
        "enable-funding": "paylater,card",
        locale: "fr_FR",
      }}>
        <PayPalButtons
          style={{ layout: "vertical", shape: "pill", color: "gold", label: "paypal" }}
          fundingSource={undefined}
          createOrder={async () => {
            const refId = await getReferenceId();
            if (!refId) throw new Error("Référence manquante");
            const body = kind === "order" ? { kind, order_id: refId } : { kind, quote_id: refId };
            const { data } = await api.post("/payments/paypal/create", body);
            return data.id;
          }}
          onApprove={async (data) => {
            try {
              const { data: res } = await api.post("/payments/paypal/capture", { paypal_order_id: data.orderID });
              if (res.status === "COMPLETED") {
                toast.success("Paiement confirmé !");
                onSuccess && onSuccess();
              } else {
                toast.error("Paiement non finalisé. Merci de réessayer.");
              }
            } catch (e) {
              toast.error(e.response?.data?.detail || "Erreur lors de la validation du paiement");
            }
          }}
          onCancel={() => toast("Paiement annulé.")}
          onError={() => toast.error("Un problème est survenu avec PayPal. Réessayez ou utilisez une autre méthode.")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
